// Hlášky pro frontend - uprav si je dle libosti
export const messages = {
  // Spojení
  noConnection: 'Barman momentálně nedostupný, zkus to znovu',

  // Notifikace
  limitExceeded: (bac: string) => `Pozor, máš toho dost! BAC: ${bac}‰`,

  // Stavy opilosti
  status: {
    sober: 'Sucho jak v poušti',
    warming: 'Rozjíždíš to',
    approaching: 'Blížíš se k ideálu',
    onTarget: 'Perfektní hladinkaaa',
    overTarget: 'Hoď to zpátečku!',
  },
};

export type MessageKey = keyof typeof messages;
